var render = function render(){var _vm=this,_c=_vm._self._c;return _c('properties-block',_vm._g(_vm._b({},'properties-block',_vm.$props,false),_vm.$listeners),[_c('properties-component-image',_vm._b({attrs:{"title":"Banner Image|Image bannière","value":_vm.block.bannerImage,"no-link":""}},'properties-component-image',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }